import { invoiceTypeArray } from "../constant/appConstant";
import { getLanguageCode } from "./common";

const getCandidateDetailsJson = (
  values: any,
  paymentTypeId: number,
  locationId = ""
) => {
  let languageCode = getLanguageCode();
  let examData: any = sessionStorage.getItem("examDetails");
  examData = JSON.parse(examData);
  let examRules: any = sessionStorage.getItem("examRulesData");
  examRules = JSON.parse(examRules);
  const body = {
    FirstName: values?.firstName,
    LastName: values?.lastName,
    DateOfBirth: `${
      values?.day?.value <= 9 ? "0" + values?.day?.value : values?.day?.value
    }/${values?.month?.value}/${values?.year?.value}`,
    Age: values?.age,
    GuardianFirstName: values?.guardianfirstName,
    GuardianLastName: values?.guardianlastName,
    GuardianMobile: values?.guardianmobilenumber,
    GuardianPhone: values?.guardianphonenumber,
    GenderId: values?.gender?.value,
    GenderName: values?.gender?.label,
    Address1: values?.address,
    Address2: values?.addressLine2,
    Address3: values?.city,
    Address4: values?.addressLine4,
    CountryId: values?.country?.value,
    CountryName: values?.country?.label,
    NationalityId: values?.nationality?.value,
    MobileNo: values?.phoneNo,
    TelephoneNo: values?.telephoneNo,
    Email: values?.guardianfirstName ? values?.guardianEmail : values?.email,
    ConfirmEmail: values?.guardianfirstName
      ? values?.guardianConfirmEmail
      : values?.confirmEmail,
    AnySpecialRequirements:
      values?.specialRequestType?.value === "1" ? "true" : "false",
    AnySpecialRequirementsName: values?.specialRequestType?.value,
    SpecialRequirements: values?.specialRequestMessage,
    IsThirdPartyInvoiceEnabledSelectedValue: values?.enableThirdParty?.label,
    IsThirdPartyInvoiceEnabled:
      values?.enableThirdParty?.value === "1" ? true : false,
    IsThirdPartyACompany:
      examRules?.examRegistrationRules?.isThirdPartyInvoiceEnabled &&
      values?.isThirdPartyCompany?.value === "1"
        ? true
        : false,
    FiscalIdentificationNumber: values?.fiscalNumber,
    PayeeOrCompanyName: values?.payeeName,
    AddressOrCompanyAdress: values?.thirdPartyAddress,
    ThirdPartyCity: values?.thirdPartyCity,
    ThirdPartyPostcode: values?.thirdPartyPostCode,
    ThirdPartyCountry: values?.thirdPartyCountry?.value,
    ThirdPartyCountryId: values?.thirdPartyCountry?.value,
    IsExamEligibleForUkVisa: examData?.isExamEligibleForUkVisa,
    ReasonForExam: values?.examReason?.value,
    ReasonForExamSelectedText: values?.examReason?.label,
    MarketingConsent: values?.MarketingConsent
      ? Number(values?.MarketingConsent)
      : 0,
    IsEIIIntegrationEnabled:
      examRules?.examRegistrationRules?.isEIIIntegrationEnabled,
    SelectedLocationId: locationId,
    TaxNumber: values?.[values?.invoiceType]?.taxNumber,
    InvoiceOrderType: invoiceTypeArray[values?.invoiceType],
    InvoiceCompanyName:
      values?.invoiceType === "company" ? values?.company?.companyName : "",
    InvoiceFamilyName:
      values?.invoiceType === "another" && values?.haveFamilyName !== "1"
        ? values?.another?.givenName
        : "N/A",
    InvoiceIsDontHaveFamilyName: values?.haveFamilyName,
    InvoiceOtherName:
      values?.invoiceType === "another" ? values?.another?.surname : "",
    InvoiceEmail: values?.[values?.invoiceType]?.email,
    InvoiceTelephoneNumber: values?.[values?.invoiceType]?.phoneNo,
    InvoiceCountryId: values?.[values?.invoiceType]?.country?.value,
    InvoiceCountryName: values?.[values?.invoiceType]?.country?.label,
    InvoiceAddress1: values?.[values?.invoiceType]?.address,
    InvoiceAddress2: "",
    InvoiceAddress3: "",
    InvoiceTownOrCity: values?.[values?.invoiceType]?.city,
    InvoicePostalCode: values?.[values?.invoiceType]?.postCode,
    ExamId: examData?.examId,
    ExamName: examData?.examName,
    RequiresPhotoConsent: 1,
    Tag: "BJiY05voGto=",
    PassportNo: values?.PassportNo,
    PassportExpiry: values?.PassportNo && !values?.skipPassportExpiry
      ? `${
          values?.passportEx?.day?.value <= 9
            ? "0" + values?.passportEx?.day?.value
            : values?.passportEx?.day?.value
        }/${values?.passportEx?.month?.value}/${
          values?.passportEx?.year?.value
        }`
      : "",
    VoiceConsent: values?.VoiceConsent ? 1 : 0,
    UkbaConsent: values?.UkbaConsent ? 1 : 0,
    PaymentTypeId: paymentTypeId,
    LanguageCode: languageCode,
    price: examData?.price,
  };
  return body;
};

export default getCandidateDetailsJson;
